<style scoped>
.product {
  display: flex;
  align-items: center;
}
.product-img {
  width: 60px;
  height: 40px;
  margin-right: 15px;
}
.product-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mb8 {
    margin-bottom: 8px;
}

.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.pdt100 {
    padding-bottom: 100px !important;
}

.header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
    position: relative;
}

.import-title.second {
    margin-top: 4px;
}

.header .title {
    text-align: center;
    flex: 1;
}

.customer-information {
    background: #fff;
    padding-bottom: 15px;
}

.customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    padding: 10px 16px;
    position: relative;
}

.sub-operate-add {
    color: #4FA1A4;
    margin-left: 14px;
    cursor: pointer;
}

.customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
}

.customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
}

.customer-information .col-itms.second {
    margin-left: 170px;
}

.customer-information .col-itms .title span {
    color: red;
}

.import-new-wrap {
    padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 175px;
    color:#999;
    font-size:12px;

}

.import-new-wrap .col-itms {
    align-items: baseline;
}

.operte-btns {
    background: #fff;
    margin-top: 4px;
    display: flex;
    justify-content: center;

}

.operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;

}

.operte-btns .btn.save {

    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
}

.operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;

}

.content-main-box {
    height: auto !important;
}

.search-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.search-wrap .input-search {
    width: 200px;
}

.sub-operate-add {
    color: #4fa1a4;
    margin-left: 14px;
    cursor: pointer;
}

.sub-operate-add2 {
    color: #4fa1a4;
    font-size: 14px;
    margin-left: 14px;
    cursor: pointer;
    position: absolute;
    right: 35px;
    top: 10px;
    text-align: center;
}

.sub-operate-del {
    font-size: 14px;
    color: #4fa1a4;
    cursor: pointer;
    text-align: center;
    margin: 0 20px;
}
</style>

<template>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
            <div class="title">申请市场拓展规划方案</div>
        </div>
        <div class="import-title">基础信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>公司名称</div>
                    <el-select @change="tenantChange" v-model="form.tenantGuid" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
                            :value="item.sendTenantGuid">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>分析目的</div>
                    <el-select @change="purposeChange" v-model="form.purposeGuid" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('分析目的')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>分析行业</div>
                    <el-select @change="form.useGuid = null; form.propertyGuid = null;" v-model="form.categoryGuid"
                        placeholder="药械分类" filterable style="width:120px;">
                        <el-option v-for="item in getCodeListByKey('药械分类')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="form.useGuid" placeholder="功能用途" filterable style="width:200px;margin:0 10px;">
                        <el-option v-for="item in getCodeListByKeyPage(form.categoryGuid == 3 ? '医疗器械管理分类' : '药品功能和用途分类')"
                            :key="item.dicValue" :label="item.dicName" :value="item.dicValue">
                        </el-option>
                    </el-select>
                    <el-select v-model="form.propertyGuid" placeholder="药品性质" filterable style="width:120px;">
                        <el-option v-for="item in getCodeListByKeyPage(form.categoryGuid == 3 ? '医疗器械68分类' : '药品性质分类')"
                            :key="item.dicValue" :label="item.dicName" :value="item.dicValue">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>分析产品</div>
                    <el-input @focus="chooseGoods" class="w300" type="input" placeholder="请选择"
                        v-model="form.goodsName"></el-input>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>分析年限</div>
                    <el-select v-model="form.yearLimit" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('分析年限')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="cols" style="position:relative">
                <div class="col-itms">
                    <div class="title"><span>*</span>推广月份</div>
                    <el-date-picker v-model="form.expandMonth" type="month" format="yyyy年MM月" placeholder="请选择推广月份"
                        class="w300" value-format="yyyyMM" :clearable="false" :disabled="disabled" />
                </div>
                <div class="col-itms second" style="position:absolute;left: 475px;z-index: 1;">
                    <div class="title"><span>*</span>市场范围</div>
                    <el-cascader :options="options" v-model="form.marketRangJson" class="w300"
                        :props="{ multiple: true, checkStrictly: true }" clearable @change="marketChange"></el-cascader>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>报告名称</div>
                    <el-input :disabled="!form.purposeGuid||!form.goodsName" rows="1" class="w300" type="text" maxlength="30" placeholder="请填写"
                        v-model="form.reportName"></el-input>
                </div>
            </div>
        </div>
        <div class="import-title second">方案信息</div>
        <div class="customer-information">
            <div class="import-new-wrap">
                <div class="cols">
                    <div class="col-itms">
                        <div class="title"><span>*</span>市场拓展规划方案</div>
                        <el-upload class="upload-demo t-left" action="#" ref="createProject" :on-remove="handleMainRemove"
                            :limit="5"
                            :on-exceed="handleExceed"
                            :file-list="form.attach" accept=".pdf,.doc,.docx" :auto-upload="true"
                            :http-request="changeMainFile">
                            <el-button size="mini" icon="el-icon-my-import" style="margin-top: 8px; margin-bottom: 0"
                                type="importNew">导入文件</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="import-step-tip">当前支持pdf、doc、docx格式文件，单个文件不得大于10M</div>
            </div>
        </div>
        <div class="flow">
            <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
        <div class="operte-btns submit-btn-box submit_btn_wrap">
            <el-button type="defalut" class="cannel-btn" size="mini" @click=" $router.go(-1)">取消</el-button>
            <el-button type="defalut" v-if="this.$route.query.type != 2" size="mini" @click=" saveReq(false)">保存</el-button>
            <el-button type="primary" size="mini" @click=" saveReq(true)">{{ this.$route.query.type == 2 ? '重新提交' : '提交申请'
            }}</el-button>
        </div>
        <!-- 选择产品 -->
        <el-dialog title="选择产品" :visible.sync="goodsDialog" width="900px">
            <el-row :gutter="24" class="mb30">
                <el-col :span="13">
                    <div class="search-area-div w80">产品名称：</div>
                    <el-input v-model="goodsPage.goodsName" class="ipt-sty" placeholder="请输入"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-button size="medium" type="info" @click="getGoodsList(true)">搜索</el-button>
                </el-col>
            </el-row>
            <el-table border  ref="multipleTable1" highlight-current-row  :data="goodsList" :row-key="(row) => row.guid"
                    @row-click="handleRowClick" @select="handleSelect">
                <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                <el-table-column prop="goodsName" label="产品" header-align="center" align="left" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="product">
                            <img class="product-img" :src="scope.row.pictContent | filterImgUrl" alt="" />
                            <p class="product-text">{{ scope.row.goodsName }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsSpec" label="规格" header-align="center" align="left" width="170"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="producer" label="生产企业" header-align="center" align="center" width="170"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="price" label="单价" header-align="center" align="right" width="120">
                    <template slot-scope="scope">
                        <!-- 固定价 -->
                        <span v-if="scope.row.priceType == '1' && scope.row.price !== 0 && scope.row.price">{{ scope.row.price
                            | numDigit | numFmt }}</span>
                        <!-- 区间价 -->
                        <span v-if="scope.row.priceType == '2'">
                            {{ scope.row.price | numDigit | numFmt }}~{{ scope.row.maxPrice | numDigit | numFmt }}
                        </span>
                        <span v-if="scope.row.priceType == '1' && (scope.row.price == 0 || !scope.row.price)">未定价</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="pt pb back-color-fff" background @size-change="handleGoodsSizeChange"
                @current-change="handleGoodsCurrentChange" :current-page="goodsPage.pageIndex"
                :page-size="goodsPage.pageSize" layout="total, prev, pager, next, jumper" :total="goodsPage.totalRows">
            </el-pagination>
            <div slot="footer" class="dialog-footer">
                <p style="font-size:16px" v-if="!currentRow&&form.goods[0]" class="t-left fl">本次已选择：{{ form.goods[0].goodsName + ' | ' + form.goods[0].goodsSpec }}</p>
                <p  style="font-size:16px" v-if="currentRow&&form.goods[0]" class="t-left fl">本次已选择：{{ currentRow.goodsName + ' | ' + currentRow.goodsSpec }}</p>
                <p  style="font-size:16px" v-if="currentRow&&!form.goods[0]" class="t-left fl">本次已选择：{{ currentRow.goodsName + ' | ' + currentRow.goodsSpec }}</p>
                <el-button plain size="medium" @click="goodsDialog = false">取消</el-button>
                <el-button size="medium" type="info" @click="sureGoods">确定</el-button>
            </div>
        </el-dialog>
        
        <ChoosePerson ref="choosePerson" :esTenantGuid="form.tenantGuid" staffType="1" @onSelect="onPersonSelect">
        </ChoosePerson>
    </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import areaJson from '../../assets/js/china_address_v4.js';
import ChoosePerson from './components/choosePersonOne';

export default {
    components: {
        ChoosePerson
    },
    data() {
        return {
            goodsDialog: false,
            goodsList: null,
            currentRowKey :null,
            currentRow:null,
            goodsPage: {
                pageIndex: 1,
                tenantGuid: '',
                pageSize: 10,
                goodsName: '',
                totalPage: 0,
                totalRows: 0,
            },
            goodsCodeList:[],
            areaData:['000000'],
            options: JSON.parse(JSON.stringify(areaJson)),
            tenantList:[],
            iframeSrc:null,
            iframeSh: false,
            dialogImageUrl: '',
            fullscreenLoading: false,
            guid: '',
            form: {
                "startAssigner":null,
                "guid": null,
                "tenantGuid": null,
                "tenantName": null,
                "expandMonth": null,//推广月份
                "reportName": null,//报告名称
                "categoryGuid": null,//药械分类
                "useGuid": null,//功能用途
                "propertyGuid": null,//药品性质
                "yearLimit": null,//分析年限
                "attach": [],
                "purposeGuid": null,//分析目的
                "goods": [],
                "immediateSubmit": null,//保存时提交流程审核true/false
                "marketRangJson": null//市场范围
            },
            personShow:false
        }
    },
    computed: {

    },
    created() {
        this.options.unshift({
            children: null,
            label: '全国',
            parentGuids: null,
            value: '000000',
            disabled: false
        });

        console.log(this.options)
        this.getTenantList();
        this.getGoodsCode();
        if (this.$route.query.guid) {
            this.getDetail();
        } else {
            this.getApprovalList();
        }
    },
    methods: {
        isLastPerson(camundaDeploymentId) {
            let self = this;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/nodes/is-need-design?deploymentId=${camundaDeploymentId}`).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.personShow = res.data.data;
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        getDetail() {
            let self = this;
            let token = localStorage.token;
            this.api.get(`/${serverConfig.msSalesPerformService}/market-expand-plan/detail/${this.$route.query.guid}`).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    let data = res.data.data;
                    this.form = {
                        "guid": data.guid,
                        "tenantGuid": data.tenantGuid,
                        "tenantName": data.tenantName,
                        "expandMonth": data.expandMonth,//推广月份
                        "reportName": data.reportName,//报告名称
                        "categoryGuid": data.categoryGuid,//药械分类
                        "useGuid": data.useGuid,//功能用途
                        "propertyGuid": data.propertyGuid,//药品性质
                        "yearLimit": data.yearLimit,//分析年限
                        "purposeGuid": data.purposeGuid,//分析目的
                        "goods": data.goods||[],
                        "marketRangJson": data.marketRangJson,//市场范围 
                        "attach": []
                    }
                    if(data.marketRangJson[0][0]=='000000'){
                        this.options.forEach(item => {
                            if (item.value !== '000000') {
                                this.$set(item, 'disabled', true)
                            }else{
                                this.$set(item, 'disabled', false)
                            }
                            if (item.children) {
                                item.children.forEach(el => {
                                    this.$set(el, 'disabled', true)
                                    if (el.children) {
                                        el.children.forEach(m => {
                                            this.$set(m, 'disabled', true)
                                        })
                                    }
                                })
                            }
                        })
                    }else{
                        this.options.forEach(item => {
                            if (item.value == '000000') {
                                this.$set(item, 'disabled', true)
                            }
                        })
                    }
                   
                    this.form.goodsName = this.getGoodsName(data.goods);
                    data.attach.forEach(item => {
                        this.form.attach.push({
                            name: item.fileName,
                            url: item.path
                        })
                    })
                    this.iframeSh = true;
                    this.iframeSrc = bpmnroute + '/iframeBpmnE?deploymentId=' + data.approveVO.camundaDeploymentId + '&token=' + token;
                    this.isLastPerson(data.approveVO.camundaDeploymentId);
                } else {
                    this.$message.error(msg);
                }
            });
        },
        tenantChange(val) {
            let item = this.tenantList.filter(item => item.sendTenantGuid == val)
            if (item.length) { //自带的
                this.form.tenantName = item[0].sendTenantName;
                this.form.tenantGuid = item[0].sendTenantGuid;
            }
        },
        getGoodsCode() {
            let self = this;
            self.api.get(
                `/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=商品大类字典`
            ).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.goodsCodeList = res.data.data;
                } else {
                    self.$message.error(res.msg || '服务异常');
                    console.log(res);
                    self.loading = false;
                }
            });
        },
        getCodeListByKeyPage(key) {
            let list = this.goodsCodeList.filter(item => item.dicName == key)
            return list.length ? list[0].childList : [];
        },
        //选择器选择后触发
        marketChange(node, resolve) {
            if (node.length == 0) {
                this.options.forEach(item => {
                    this.$set(item, 'disabled', false)
                    if (item.children) {
                        item.children.forEach(el => {
                            this.$set(el, 'disabled', false)
                            if (el.children) {
                                el.children.forEach(m => {
                                    this.$set(m, 'disabled', false)
                                })
                            }
                        })
                    }
                })
            } else {
                Array.from(node, (choose) => {//遍历node集合
                    console.log(choose)
                    if (choose[0] == "000000") {
                        this.areaData = ["000000"]//清空之前的选择
                        this.options.forEach(item => {
                            if (item.value !== '000000') {
                                this.$set(item, 'disabled', true)
                            }
                            if (item.children) {
                                item.children.forEach(el => {
                                    this.$set(el, 'disabled', true)
                                    if (el.children) {
                                        el.children.forEach(m => {
                                            this.$set(m, 'disabled', true)
                                        })
                                    }
                                })
                            }
                        })
                    } else {
                        this.options.forEach(item => {
                            if (item.value == '000000') {
                                this.$set(item, 'disabled', true)
                            } else {
                                this.$set(item, 'disabled', false)
                                if (item.children) {
                                    item.children.forEach(el => {
                                        this.$set(el, 'disabled', false)
                                        if (el.children) {
                                            el.children.forEach(m => {
                                                this.$set(m, 'disabled', false)
                                            })
                                        }
                                    })
                                }
                            }

                        })
                    }
                })
            }
        },
        getTenantList(val) {
            let self = this;
            let query ={
              'pageIndex':1,
              'pageSize':-1,
              'bizState':'Y',
              'enterpriseCates':this.$getValueListByKey('上游客户分类')
            }
            self.api
            .postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,query)
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        self.tenantList = res.data.data.records || [];
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
        //获取流程列表
        getApprovalList() {
            let userinfo = JSON.parse(localStorage.userInfo);
            let token = localStorage.token;
            let req = {
                tenantGuid: localStorage.guid,
                flowType: '00027',
                staffGuid: userinfo.staffGuid
            }
            this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    if (!res.data.data) {
                        this.$message.error('没有找到规则,请先联系运营人员设置当前部门的流程规则');
                        this.iframeSh = false;
                    } else {
                        this.iframeSh = true;
                        this.iframeSrc = bpmnroute + '/iframeBpmnE?deploymentId=' + res.data.data + '&token=' + token;
                        this.isLastPerson(res.data.data)
                    }
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        changeMainFile(file) {
            let isLt5M = file.file.size / 1024 / 1024 < 20;
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 20MB');
                this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('fileName', file.file.name);
            this.fullscreenLoading = true;
            this.api.postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.form.attach.push({
                        name: file.file.name,
                        url: res.data.data.data,
                    });
                    console.log(this.form.attach)
                    this.$message({
                        message: '上传成功',
                        type: 'success',
                    });
                }
            }).catch(() => {
                this.$message('上传失败！');
            });

        },
        handleMainRemove(file) {
            let attach = this.form.attach;
            attach.forEach((item, index) => {
                if (item.url == file.url) {
                    attach.splice(index, 1)
                }
            })
            this.form.attach = attach;
            console.log(file);
        },
        checkForm() {
            if (!this.form.tenantGuid) {
                this.$message.error('公司名称不能为空')
                return false;
            }
            if (!this.form.purposeGuid) {
                this.$message.error('分析目的不能为空')
                return false;
            }
            if (!this.form.reportName) {
                this.$message.error('报告名称不能为空')
                return false;
            }
            if (!this.form.categoryGuid) {
                this.$message.error('药械分类不能为空')
                return false;
            }
            if (!this.form.useGuid) {
                this.$message.error('功能用途不能为空')
                return false;
            }
            if (!this.form.propertyGuid) {
                this.$message.error('药品性质不能为空')
                return false;
            }
            if (!this.form.goodsName) {
                this.$message.error('分析产品不能为空')
                return false;
            }
            if (!this.form.yearLimit) {
                this.$message.error('分析年限不能为空')
                return false;
            }
            if (!this.form.expandMonth) {
                this.$message.error('推广月份不能为空')
                return false;
            }

            if (!this.form.marketRangJson) {
                this.$message.error('市场范围不能为空')
                return false;
            }
      
            if (!this.form.attach.length) {
                this.$message.error('市场拓展规划方案不能为空')
                return false;
            }

            return true;
        },
        onPersonSelect([personGuid, data]) {
            this.form.startAssigner = personGuid.join(',');
            if (!this.form.startAssigner) {
                this.$message.error('请先选择人员!')
                return;
            }
            this.submitData(true);
        },
        saveReq(immediateSubmit) {
            if (!this.checkForm()) return;
            if (this.personShow == true && !this.form.startAssigner && immediateSubmit) {
                this.$refs.choosePerson.visible = true;
            } else {
                this.submitData(immediateSubmit);
            }
        },
        submitData(immediateSubmit) {
            let reqUrl = `/${serverConfig.msSalesPerformService}/market-expand-plan/add`;
            let req = JSON.parse(JSON.stringify(this.form));
            let userinfo = JSON.parse(localStorage.userInfo);
            req.immediateSubmit = immediateSubmit;
            req.applyStaffName = userinfo.staffName;
            req.applyStaffGuid = userinfo.staffGuid;
            req.serviceTenantGuid = localStorage.guid;
            if (req.attach && req.attach.length) {
                let attach = [];
                req.attach.forEach(itme => {
                    attach.push({
                        fileName: itme.name,
                        path: itme.url
                    })
                })
                req.attach = attach;
            }
            this.fullscreenLoading = true;
            if (this.$route.query.guid) {
                req.guid = this.$route.query.guid;
                req['guidResubmit'] = this.$route.query.type == 2 ? this.$route.query.guid : null;
                reqUrl = `/${serverConfig.msSalesPerformService}/market-expand-plan/update`;
                this.api.put(reqUrl, req).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                        });
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            } else {
                this.api.postJson(reqUrl, req).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        this.$message({
                            message: '提交成功',
                            type: 'success',
                        });
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }

        },
        getGoodsList(val) {
            if (val) {
                this.goodsPage = {
                    pageIndex: 1,
                    tenantGuid: this.form.tenantGuid,
                    pageSize: 10,
                    totalPage: 0,
                    totalRows: 0,
                    goodsName: this.goodsPage.goodsName,
                }
            }
            this.goodsPage.tenantGuid = this.form.tenantGuid;
            this.api.postCan(
                `/${serverConfig.msProductService}/goods/data/get`,
                this.goodsPage
            ).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.goodsList = res.data.data.records;
                    this.goodsPage.totalPage = res.data.data.totalPages;
                    this.goodsPage.totalRows = res.data.data.totalRows;
                } else {
                    self.$message.error(res.data.data.msg);
                }
            });
        },
        getGoodsName(res) {
            var list = [];
            if (!res) return '';
            if (res.length >= 2) {
                res.forEach((item, index) => {
                    if (index <= 1) {
                        list.push(item.goodsName);
                    }
                });
                return list.join("、") + "等" + res.length + "个产品";
            } else {
                return res[0].goodsName;
            }
        },
        handleGoodsSizeChange(val) {
            this.goodsPage.pageIndex = val;
            this.getGoodsList();
        },
        handleGoodsCurrentChange(val) {
            this.goodsPage.pageIndex = val;
            this.getGoodsList();
        },
        handleRowClick(row) {
            this.$refs.multipleTable1.clearSelection();
            row.flag = !row.flag;
            this.$refs.multipleTable1.toggleRowSelection(row, row.flag);
            this.currentRowKey = row.guid;
            this.currentRow = row;
        },
        handleSelect(selection, row) {
            this.$refs.multipleTable1.clearSelection();
            if (selection.length == 0) {
                return;
            }
            if (row) {
                this.currentRow = row;
                this.currentRowKey = row.guid;
                this.$refs.multipleTable1.toggleRowSelection(row, true);
            }
        },
        chooseGoods(){
            if (!this.form.tenantGuid) {
                this.$message.error('请先选择公司')
                return ;
            }
            this.goodsDialog = true;
            this.getGoodsList(true)
        },
        sureGoods() {
            if (!this.currentRow&&!this.form.goods[0]) {
                this.$message.error('请选择产品！');
                return;
            }
            if(!this.currentRow&&this.form.goods[0]){
                this.goodsDialog = false;
                return;
            }
            if(this.currentRow&&!this.form.goods[0]){
                this.goodsDialog = false;
            }
            let goods = [];
            goods.push({
                goodsGuid: this.currentRow.guid,
                goodsName: this.currentRow.goodsName,
                goodsSpec: this.currentRow.goodsSpec,
            })
            this.form.goods = goods;
            this.form.goodsName = this.getGoodsName(goods);
            if (this.currentRow.goodsName && this.form.purposeGuid) {
                this.form.reportName = this.currentRow.goodsName + '' + this.getName(this.form.purposeGuid, '分析目的')
            }
            this.goodsDialog = false;
        },
        getName(name, key) {
            if (!name) return '-';
            let list = this.getCodeListByKey(key);
            if (typeof name == 'object') {
                let newArr = [];
                name.forEach(item => {
                    list.forEach(el => {
                        if (el.value == item) {
                            newArr.push(el.text);
                        }
                    })
                })
                return newArr.length ? newArr.join('、') : '-';
            } else {
                let lisArr = list.filter(item => item.value == name);
                return lisArr.length ? lisArr[0].text : '-';
            }

        },
        purposeChange() {
            if (this.form.goodsName && this.form.purposeGuid) {
                this.form.reportName = this.form.goodsName + '' + this.getName(this.form.purposeGuid, '分析目的')
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
    }
};
</script> 